<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const areaListTitle = '各地の風の予報'
</script>

<template>
  <div class="spotlist">
    <SectionTitle :title="areaListTitle" />
    <ul class="block">
      <li
        v-for="area in areaToPrefTable"
        :key="area.key"
        class="list"
      >
        <NuxtLink
          :to="`/${area.key}/`"
          class="title"
        >
          {{ area.name }}
        </NuxtLink>
        <ul
          v-if="Object.keys(area.pref_list).length > 0"
          class="parents"
        >
          <li
            v-for="pref in area.pref_list"
            :key="pref.key"
            class="inner"
          >
            <NuxtLink
              :to="`/${area.key}/${pref.key}/`"
              class="link"
            >
              {{ pref.name }}
            </NuxtLink>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 10px;
    background-color: #EEF1F8;
  }
  .list {
    display: flex;
    align-items: center;
    gap: 15px;
    & > .title {
      width: 70px;
    }
  }
  .inner {
    display: block;
    color: #3569c0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
    text-decoration: underline;
  }
  .title {
    position: relative;
    width: calc((100% - 10px) / 3);
    padding: 5px 5px 4px;
    border-radius: 2px;
    border: 1px solid #3569C0;
    background-color: #fff;
    color: #3569C0;
    font-size: 15px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    user-select: none;
    &::after {
      position: absolute;
      bottom: 4px;
      right: 4px;
      width: 9px;
      height: 9px;
      background-color: #3569C0;
      clip-path: polygon(100% 0, 100% 100%, 0 100%);
      content: '';
    }
    @media (any-hover: hover) {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
  .link {
    display: block;
    color: #3569c0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
    text-decoration: underline;
  }
  .parents {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    flex: 1;
  }
  .text {
    color: #303030;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
  }
  @media screen and (min-width: 830px) {
    .title {
      width: calc((100% - 16px) / 3);
    }
    .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
